export default __webpack_public_path__ + "static/media/bx-twitter.95ff96f9.svg";